import getURLSearchParam from '@zhenguo/jssdk/base/url'
import { genOtherActUrl } from '@zhenguo/jssdk/act-url'

export const EVENTS = {
  jump2activity: 'jump2activity',
  completeVerified: 'complete-verified',
  hasVerified: 'has-verified',
  verifyPending: 'verify-pending',
  refresh: 'refresh',
}

export const APPLY_TYPE = {
  NORMAL: 0,
  HIGHSCHOOL: 1,
}

export const CUSTOM_UNIVERSITY_ID = 0

export const DEGREE = {
  MIDSCHOOL: 1,
  HIGHSCHOOL: 6,
}

export const DEFAULT_DEGRESS_LIST = [
  { degree: 2, label: '专科' },
  { degree: 3, label: '本科' },
  { degree: 4, label: '硕士' },
  { degree: 5, label: '博士' },
]

const startyear = new Date().getFullYear() - 5
export const START_YEAR_LIST = Array.from({ length: 6 }, (_item, index) => startyear + index)

export enum CERT_STATUS {
  PENDING = 1, // 待完成认证
  COMPLETED = 2, // 认证完成
  COMPLETED_ADDITIONAL = 3, // 认证完成(额外认证)
  FAILED = 4, // 认证失败
}

export enum CERT_TYPE {
  NORMAL = 0, // 在校生认证
  HIGH_S = 1, // 应届高考生认证
  OTHER = 2, // 其他院校
}

export enum AUDIT_STATUS {
  PENDING = 0, // "待审核"
  APPROVAL = 1, // "审核通过"
  REJECT = 2, // "审核不通过"
}

export enum LX_CERTIFICATION_STATUS {
  INIT = 0,
  FAIL = 1,
  PENDING = 2,
}

export const DEFAULT_THEME_CONFIG = {
  key: 'default',
  helpUrl: '',
  successDialogBtnLabel: '立即享受特权',
  successDialogBtnUrl: genOtherActUrl('edu'),
  verifiedBtnLabel: '前往享受特权',
  verifiedBtnUrl: genOtherActUrl('edu'),
  loginFirst: false,
  source: 2,
  displayHS: true, // 展示高考生
}

export enum SOURCE {
  DEFAULT = 0, // 默认
  BD = 1, // 地推
  ACTIVITY = 2, // 活动
  PARTTIME = 3, // 向日葵兼职 https://km.sankuai.com/page/176683887
  VUE = 5,
  INMENG = 6, // 印萌
  ICEBEAR = 8, // 白熊
}

const phxFrom = getURLSearchParam('phx_from')
const requestId = getURLSearchParam('requestId')

export function getExtensions(source: SOURCE) {
  const commonData: Record<string, string> = {
    activity: phxFrom,
  }
  const paramKey = [['phx_from', 'activity'], 'theme', 'actIdentifier', 'launchId', 'bid']
  for (const key of paramKey) {
    let queryKey = ''
    let objKey
    if (Array.isArray(key) && key[0] && key[1]) {
      queryKey = key[0]
      objKey = key[1]
    } else {
      queryKey = objKey = key as string
    }
    let value = getURLSearchParam(queryKey)
    if (value) {
      if (objKey === 'activity' && (value === 'pin' || value === 'pin_assist')) {
        value = 'ifoging'
      }
      commonData[objKey] = value
    }
  }
  switch (source) {
    case SOURCE.PARTTIME:
      return {
        ...commonData,
        parttimeRequestId: requestId,
      }
    case SOURCE.ICEBEAR:
      return {
        ...commonData,
        extra: getURLSearchParam('extra'),
      }
    default:
      return commonData
  }
}

export function getExtensionsStr(source: SOURCE) {
  return JSON.stringify(getExtensions(source))
}

export function isValidStartYear(startYear: number, startYearList: number[]) {
  if (!startYear) return false
  return Number(startYear) && startYearList.indexOf(Number(startYear)) !== -1
}

// 其它院校 universityId 为 0
export function isValidUniversityId(universityId: number) {
  return Number.isInteger(universityId) && universityId >= 0
}
